// Returns the `response` of a failed axios request (or of anything else that has one), for error handling in actions
export const getErrorResponse = (error: unknown): unknown => (
    error instanceof Object && 'response' in error ? error.response : undefined
)
